"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.resolveEndpoints = void 0;

var _serviceNames = require("./service-names");

/* eslint-disable import/prefer-default-export */
var resolveEndpoints = function resolveEndpoints(serviceName) {
  var catalogId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var isPEPGateway = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (serviceName === _serviceNames.SERVICE_NAMES.RESOURCE_CENTER) {
    return {
      TOKEN: "/api/v1/authentication/token",
      FILTERS: "/api/v1/resources/filters",
      RESOURCES: "/api/v1/resources",
      PRODUCT_RESOURCES: "/api/v1/productresources"
    };
  }

  if (serviceName === _serviceNames.SERVICE_NAMES.PEP) {
    return {
      TOKEN: "/api/v1/authentication/token",
      PRODUCT_DETAILS: "/api/v1/product/product-details",
      RELATED_ACCESSORIES: "/api/v1/product/related-accessories",
      BROWSE_ACCESSORIES: "/api/v1/product/browse/accessories",
      BROWSE_HEARING_AIDS: "/api/v1/product/browse/hearingaids",
      BROWSE_MARKETING_MATERIALS: "/api/v1/product/browse/marketingmaterials"
    };
  }

  if (serviceName === _serviceNames.SERVICE_NAMES.COMPATIBILITY_GUIDE) {
    if (isPEPGateway) {
      return {
        TOKEN: "/api/v2/authentication/token",
        APPS: catalogId ? "/api/v2/catalogs/".concat(catalogId, "/apps") : "",
        ACCESSORIES: catalogId ? "/api/v2/catalogs/".concat(catalogId, "/accessories") : "",
        DEVICES: "/api/v3/devices",
        PRODUCTS: "/api/v3/catalogs/".concat(catalogId, "/hearing-aids/summaries")
      };
    } else {
      return {
        TOKEN: "/api/v1/authentication/token",
        APPS: "/api/v1/compatibility/apps",
        ACCESSORIES: "/api/v1/compatibility/accessories",
        DEVICES: "/api/v1/compatibility/devices",
        PRODUCTS: "/api/v1/compatibility/hearingaids"
      };
    }
  } else {
    return null;
  }
};

exports.resolveEndpoints = resolveEndpoints;
var _default = resolveEndpoints;
exports["default"] = _default;